import React, { useContext, useState } from "react";
import PackagesRatesForms from "../../FormsTariff/PackagesRatesForms";
import CustomTabs from "../../../CommonElements/CommonTabs/CustomTabs";
import TariffModal from "../../../CommonElements/TariffModal/TariffModal";


function CreatePackageRateFlow({ isOpen, handleCloseModal, corpObj}) {
  const [title,setTitle] = useState("Create Package Rate")

  const tabs = [
    {
      label: "Package Rates",
      content:
        <PackagesRatesForms createdPackage={corpObj} setTitle={setTitle}/>
    },
  ];

  return (
    <div>
      <TariffModal
       isOpen={isOpen}
       size="xl"
       centered
       toggler={handleCloseModal}
       title={title}
      >
        <CustomTabs tabs={tabs} />
      </TariffModal>
    </div>
  );
}

export default CreatePackageRateFlow;
